import { render, staticRenderFns } from "./QrCodeExample.vue?vue&type=template&id=4b086440"
import script from "./QrCodeExample.vue?vue&type=script&lang=js"
export * from "./QrCodeExample.vue?vue&type=script&lang=js"
import style0 from "./QrCodeExample.vue?vue&type=style&index=0&id=4b086440&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b086440')) {
      api.createRecord('4b086440', component.options)
    } else {
      api.reload('4b086440', component.options)
    }
    module.hot.accept("./QrCodeExample.vue?vue&type=template&id=4b086440", function () {
      api.rerender('4b086440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/flow/identifiers/components/QrCodeExample.vue"
export default component.exports